/**
 *
 * AppAuthenticators
 *
 */

import { connect, ConnectedProps } from "react-redux";
import { compose } from "redux";
import { injectReducer, injectSaga, SagaInjectionModes } from "redux-injectors";

import Layout from "./layout";
import selectAppAuthenticatorsDataProps from "./selectors";

import reducer, { actionProps } from "./redux";
import saga from "./saga";

const mapStateToProps = selectAppAuthenticatorsDataProps;
const mapDispatchToProps = actionProps;

const withConnect = connect<
  ReturnType<typeof mapStateToProps>,
  ReturnType<typeof mapDispatchToProps>,
  {} // own props type
>(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: "appAuthenticators", reducer });
const withSaga = injectSaga({
  key: "appAuthenticators",
  saga,
  mode: SagaInjectionModes.RESTART_ON_REMOUNT,
});

export default compose(
  withConnect,
  withReducer,
  withSaga
)(Layout as React.ComponentType<ConnectedProps<typeof withConnect>>);
